import request from '../../utils/axios';

function unwrap(promise) {
    return promise.then((res) => {
        const body = res && res.data;
        if (!body) {
            return Promise.reject(new Error('接口异常'));
        }
        if (body.code == 0) {
            return Promise.reject(body);
        }
        return body;
    });
}

// 报备类型列表
export function reportTypeList(params) {
    return unwrap(request({
        url: '/h5/order/report/type',
        method: 'get',
        params
    }));
}

// 获取报备列表/详情
export function getReport(params = {}) {
    return unwrap(request({
        url: '/h5/order/report',
        method: 'get',
        params: {
            last_id: 0,
            page: 1,
            limit: 1000,
            ...params
        }
    }));
}

// 新增报备
export function createReport(data) {
    return unwrap(request({
        url: '/h5/order/report',
        method: 'post',
        data
    }));
}

// 回复报备
export function reportReply(data) {
    return unwrap(request({
        url: '/h5/order/report/reply',
        method: 'post',
        data
    }));
}

// 同意报备内容（议价等）
export function reportContentAgree(data) {
    return unwrap(request({
        url: '/h5/order/report/content/agree',
        method: 'post',
        data
    }));
}

// 标记报备已读
export function reportRead(data) {
    return unwrap(request({
        url: '/h5/order/report/read',
        method: 'post',
        data
    }));
}

// 关闭/取消报备
export function reportClose(data) {
    return unwrap(request({
        url: '/h5/order/report/close',
        method: 'post',
        data
    }));
}
